<template>
    <div class="home-page">
        <!-- 个人信息名片 -->
        <div class="profile-card">
            <div class="profile-banner">
                <div class="profile-banner-left">
                    <img class="user-avatar" :src="avatarUrl" alt="用户头像" />
                    <div class="profile-info">
                        <div class="company-name">{{ userInfo.name }}</div>
                        <div class="auth-row">
                            <span v-if="userInfo.status == 1001">
                                <span v-if="authState == '未认证'" class="auth-tag auth-pending">
                                    <i class="el-icon-warning-outline"></i> 未认证
                                </span>
                                <span v-if="authState == '认证中'" class="auth-tag auth-processing">
                                    <i class="el-icon-loading"></i> 认证中
                                </span>
                                <span v-if="authState == '认证成功'" class="auth-tag auth-success">
                                    <i class="el-icon-circle-check"></i> 已认证
                                </span>
                                <span v-if="authState == '认证驳回'" class="auth-tag auth-failed">
                                    <i class="el-icon-circle-close"></i> 认证失败
                                </span>
                            </span>
                            <el-button v-if="userInfo.status == 1001 && authState == '未认证'"
                                size="mini" class="btn-goto"
                                @click="$router.push('/index/authDetail')">去认证</el-button>
                            <el-button v-if="userInfo.status == 1001 && authState == '认证审核驳回'"
                                size="mini" class="btn-goto"
                                @click="$router.push('/detailInfo')">去完善</el-button>
                        </div>
                    </div>
                </div>
                <div class="role-badge">{{ role }}</div>
            </div>
        </div>

        <!-- 待办 + 消息 -->
        <el-row :gutter="20" style="margin-top:20px;">
            <!-- 我的待办 -->
            <el-col :span="14">
                <el-card shadow="never" class="list-card">
                    <div class="list-card-header">
                        <div class="list-card-title">
                            <span class="title-dot todo-dot"></span>
                            <i class="el-icon-document-checked"></i>
                            我的待办
                            <el-badge :value="noticeContent_1.length" :max="99" class="count-badge" />
                        </div>
                        <el-button type="text" size="mini" class="more-btn"
                            @click="$router.push('/ToDoInfo')">
                            更多 <i class="el-icon-arrow-right"></i>
                        </el-button>
                    </div>
                    <div class="list-body">
                        <div v-if="noticeContent_1.length === 0" class="empty-state">
                            <img src="@/assets/img/nothing.png" alt="暂无数据" class="empty-img">
                            <div class="empty-text">暂无待办事项</div>
                        </div>
                        <div v-else>
                            <div v-for="(content, index) in noticeContent_1.slice(0, 6)" :key="index"
                                class="todo-item" @click="handleTodoClick(content)">
                                <div class="todo-dot-line"></div>
                                <div class="todo-main">
                                    <div class="todo-content">{{ content.content }}</div>
                                    <div class="todo-meta">
                                        <el-tag size="mini" type="primary" effect="plain">{{ content.title }}</el-tag>
                                        <span class="todo-time">{{ formatTime(content.createTime) }}</span>
                                    </div>
                                </div>
                                <i class="el-icon-arrow-right todo-arrow"></i>
                            </div>
                        </div>
                    </div>
                </el-card>
            </el-col>

            <!-- 我的消息 -->
            <el-col :span="10">
                <el-card shadow="never" class="list-card">
                    <div class="list-card-header">
                        <div class="list-card-title">
                            <span class="title-dot msg-dot"></span>
                            <i class="el-icon-bell"></i>
                            我的消息
                            <el-badge :value="noticeContent_2.length" :max="99" class="count-badge" />
                        </div>
                        <el-button type="text" size="mini" class="more-btn"
                            @click="$router.push('/messageInfo')">
                            更多 <i class="el-icon-arrow-right"></i>
                        </el-button>
                    </div>
                    <div class="list-body">
                        <div v-if="noticeContent_2.length === 0" class="empty-state">
                            <img src="@/assets/img/nothing.png" alt="暂无数据" class="empty-img">
                            <div class="empty-text">暂无消息</div>
                        </div>
                        <div v-else>
                            <div v-for="(content, index) in noticeContent_2.slice(0, 6)" :key="index"
                                class="message-item">
                                <i class="el-icon-chat-dot-round msg-icon"></i>
                                <div class="message-main">
                                    <div class="message-content">{{ content.content }}</div>
                                    <div class="message-time">{{ formatTime(content.createTime) }}</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </el-card>
            </el-col>
        </el-row>
    </div>
</template>

<script>
export default {
    name: "Home",
    data() {
        return {
            activeTab: "教务通知公告",
            userInfo: "",
            role: "",
            avatarUrl: "",
            city: "",
            position: {
                city: "",
                province: "",
            },
            authState: "",
            companyName: "",
            orgOptions: {},
            noticeContent_1: [],
            noticeContent_2: [],
            currPage1: 1,
            currPage2: 1,
            hasNextPage1: false,
            hasPrePage1: false,
            hasNextPage2: false,
            hasPrePage2: false,
        };
    },
    mounted() {
        //数据的初始化
        //this.drawVisitedNum();
        //this.drawAcademyNum();
        //document.querySelector('body').setAttribute('style', 'background: #f0f0f0');
        this.initBoardContent();


        this.userInfo = JSON.parse(localStorage.getItem("user"));

        console.log("身份：" , this.userInfo);
        if (this.userInfo.status === 1001) {
            this.role = "企业用户";
        } else {
            this.role = "平台运营";
        }

        if (this.userInfo.avatar === "") {
            this.avatarUrl = require("../../assets/user_pic_middle.gif");
        } else {
            this.avatarUrl = this.userInfo.avatar;
        }

        const _this = this;
        AMap.plugin("AMap.CitySearch", function () {
            var citySearch = new AMap.CitySearch();
            citySearch.getLocalCity(function (status, result) {
                if (status === "complete" && result.info === "OK") {
                    // 查询成功，result即为当前所在城市信息
                    _this.position.city = result.city;
                    _this.position.province = result.province;
                }
            });
        });
    },
    methods: {
        formatTime(timeStr) {
            if (!timeStr) return '';
            const date = new Date(timeStr);
            return `${date.getFullYear()}-${(date.getMonth() + 1).toString().padStart(2, '0')}-${date.getDate().toString().padStart(2, '0')} ${date.getHours().toString().padStart(2, '0')}:${date.getMinutes().toString().padStart(2, '0')}`;
        },
        initBoardContent() {
            let user = JSON.parse(window.localStorage.getItem('user'));
            //console.log("useid: " + user.id);

            // 获取消息数据
            this.getRequest("/web/messageInfo/queryToDo?userId=" + user.id)
                .then((resp) => {
                    this.noticeContent_1 = resp.data.map(item => ({
                        title: item.title,
                        content: item.content,
                        referenceId: item.referenceId,
                        createTime: item.sendTime
                    }));
                });
            // 
            this.getRequest("/web/messageInfo/queryMeg?userId=" + user.id)
                .then((resp) => {
                    this.noticeContent_2 = resp.data.map(item => ({
                        title: item.title,
                        content: item.content,
                        referenceId: item.referenceId,
                        createTime: item.sendTime
                    }));
                });

            // 原有认证状态查询
            this.getRequest("/web/companyInfo/queryAuthState?userId=" + user.id)
                .then((resp) => {
                    this.authState = resp.data.authState;
                    this.companyName = resp.data.companyName;
                });
        },
        avatarClick() {
            //console.log('尝试跳转到个人中心');
            if (this.$router) {
                this.$router.push('/index/center').then(() => {
                    //console.log('路由跳转成功');
                }).catch(err => {
                    console.error('路由跳转失败:', err);
                    this.$message.error('跳转失败，请检查路由配置');
                    window.location.href = '/index/center';
                });
            } else {
                console.warn('Vue Router不可用，使用原生跳转');
                window.location.href = '/index/center';
            }
        },

        contentClick(val) {
            this.$store.state.boardId = val;
            this.$router.replace("/boardDetails");
        },

        handleTodoClick(content) {
            if (content.title === '企业信息认证审核') {
                this.$router.push({ path: '/index/company/company-review', query: { companyId: content.referenceId } });
            } else if (['资产认证待审核', '资产认证待复审', '资产认证待终审'].includes(content.title)) {
                this.$router.push({ path: '/index/data-review', query: { registrationId: content.referenceId } });
            }
        },
        tabClick(tab) {
            this.activeTab = tab.name;
            this.initBoardContent();
        },
        changePage1(val) {
            if (val && this.hasNextPage1) {
                this.currPage1 = this.currPage1 + 1;
                this.initBoardContent();
            }
            if (!val && this.hasPrePage1) {
                this.currPage1 = this.currPage1 - 1;
                this.initBoardContent();
            }
        },
        changePage2(val) {
            if (val && this.hasNextPage1) {
                this.currPage2 = this.currPage2 + 1;
                this.initBoardContent();
            }
            if (!val && this.hasPrePage1) {
                this.currPage2 = this.currPage2 - 1;
                this.initBoardContent();
            }
        },
    },
};
</script>

<style scoped>
.home-page {
    padding: 20px 28px 40px;
    min-height: calc(100vh - 60px);
    box-sizing: border-box;
}

/* ===== 个人信息卡 ===== */
.profile-card {
    border-radius: 12px;
    overflow: hidden;
    box-shadow: 0 2px 12px rgba(64, 158, 255, 0.12);
}

.profile-banner {
    background: linear-gradient(135deg, #1a6fcf 0%, #409EFF 60%, #66b1ff 100%);
    padding: 28px 32px;
    display: flex;
    align-items: center;
    justify-content: space-between;
}

.profile-banner-left {
    display: flex;
    align-items: center;
    gap: 20px;
}

.user-avatar {
    width: 80px;
    height: 80px;
    border-radius: 50%;
    border: 3px solid rgba(255, 255, 255, 0.8);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
    object-fit: cover;
    flex-shrink: 0;
}

.profile-info {
    display: flex;
    flex-direction: column;
    gap: 10px;
}

.company-name {
    font-size: 22px;
    font-weight: 600;
    color: #fff;
    text-shadow: 0 1px 3px rgba(0,0,0,0.1);
}

.auth-row {
    display: flex;
    align-items: center;
    gap: 10px;
}

.auth-tag {
    display: inline-flex;
    align-items: center;
    gap: 4px;
    padding: 3px 10px;
    border-radius: 20px;
    font-size: 13px;
    font-weight: 500;
}

.auth-pending  { background: rgba(255,255,255,0.2); color: #fff; }
.auth-processing { background: rgba(255,255,255,0.25); color: #fff; }
.auth-success  { background: rgba(103,194,58,0.25); color: #e8f8d8; border: 1px solid rgba(103,194,58,0.5); }
.auth-failed   { background: rgba(245,108,108,0.25); color: #ffe0e0; border: 1px solid rgba(245,108,108,0.5); }

.btn-goto {
    background: rgba(255,255,255,0.2);
    border: 1px solid rgba(255,255,255,0.6);
    color: #fff;
    border-radius: 16px;
    padding: 4px 14px;
    font-size: 12px;
    transition: background 0.2s;
}
.btn-goto:hover { background: rgba(255,255,255,0.35); }

.role-badge {
    background: rgba(255,255,255,0.18);
    border: 1px solid rgba(255,255,255,0.5);
    color: #fff;
    padding: 6px 18px;
    border-radius: 20px;
    font-size: 14px;
    font-weight: 500;
    white-space: nowrap;
}

/* ===== 列表卡片 ===== */
.list-card {
    border-radius: 12px;
    border: none;
    box-shadow: 0 2px 10px rgba(0,0,0,0.07);
}

.list-card-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding-bottom: 14px;
    margin-bottom: 4px;
    border-bottom: 1px solid #eef0f4;
}

.list-card-title {
    display: flex;
    align-items: center;
    gap: 6px;
    font-size: 15px;
    font-weight: 600;
    color: #303133;
}

.title-dot {
    display: inline-block;
    width: 4px;
    height: 16px;
    border-radius: 2px;
    margin-right: 2px;
}
.todo-dot { background: #409EFF; }
.msg-dot  { background: #67C23A; }

.list-card-title i {
    font-size: 16px;
    color: #606266;
}

.count-badge {
    margin-left: 4px;
}
.count-badge >>> .el-badge__content {
    font-size: 11px;
    height: 16px;
    line-height: 16px;
    padding: 0 5px;
    border-radius: 8px;
}

.more-btn {
    color: #909399;
    font-size: 13px;
}
.more-btn:hover { color: #409EFF; }

.list-body {
    min-height: 220px;
    max-height: 320px;
    overflow-y: auto;
    padding-right: 2px;
}

/* 待办条目 */
.todo-item {
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 12px 10px;
    border-radius: 8px;
    cursor: pointer;
    transition: background 0.18s;
    margin-bottom: 4px;
}
.todo-item:hover {
    background: #f0f6ff;
}
.todo-item:hover .todo-arrow { color: #409EFF; }

.todo-dot-line {
    width: 8px;
    height: 8px;
    background: #409EFF;
    border-radius: 50%;
    flex-shrink: 0;
}

.todo-main {
    flex: 1;
    overflow: hidden;
}

.todo-content {
    font-size: 14px;
    color: #303133;
    font-weight: 500;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    margin-bottom: 5px;
}

.todo-meta {
    display: flex;
    align-items: center;
    gap: 8px;
}

.todo-time {
    font-size: 12px;
    color: #c0c4cc;
    margin-left: auto;
    white-space: nowrap;
}

.todo-arrow {
    color: #dcdfe6;
    font-size: 13px;
    flex-shrink: 0;
    transition: color 0.18s;
}

/* 消息条目 */
.message-item {
    display: flex;
    align-items: flex-start;
    gap: 10px;
    padding: 11px 10px;
    border-radius: 8px;
    margin-bottom: 4px;
    transition: background 0.18s;
}
.message-item:hover { background: #f4fff0; }

.msg-icon {
    font-size: 16px;
    color: #67C23A;
    margin-top: 2px;
    flex-shrink: 0;
}

.message-main {
    flex: 1;
    overflow: hidden;
}

.message-content {
    font-size: 13px;
    color: #606266;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    margin-bottom: 4px;
}

.message-time {
    font-size: 11px;
    color: #c0c4cc;
}

/* 空状态 */
.empty-state {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 50px 0 30px;
}
.empty-img {
    width: 80px;
    height: 80px;
    opacity: 0.4;
    margin-bottom: 10px;
}
.empty-text {
    color: #c0c4cc;
    font-size: 13px;
}

/* 滚动条美化 */
.list-body::-webkit-scrollbar { width: 4px; }
.list-body::-webkit-scrollbar-thumb { background: #dcdfe6; border-radius: 2px; }
.list-body::-webkit-scrollbar-track { background: transparent; }

@media (max-width: 992px) {
    .home-page { padding: 14px; }
    .el-col { margin-bottom: 16px; }
}
</style>